var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/278dfa6b32c64838e8ee182ec4fa9e93.js').default;
var scope_1 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/855daf70944d45cfdf3a8fb97b597aba.js').default;
var scope_2 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e1f0604493e70e74ca61ee2cf1de37aa.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2 )
    